import Service from "../Service";

const resource = "SecAlert/";

export default {
    /* check(requestID) {
        return Service.post(
            "alert/check", {}, {
                params: { requestID: requestID },
            }
        );
    },

    byAlert(alert, requestID) {
        return Service.post(
            "transaction/byalert",
            alert, {
                params: { requestID: requestID },
            }
        );
    }, */

    pagination(dtr, requestID) {
        return Service.post(
            resource + "pagination",
            dtr, {
                params: { requestID: requestID },
            }
        );
    },

};